/**
 * Liturgical 도메인 Zod 스키마
 * 천주교 전례력 관련 (의무축일 등)
 */
import { z } from 'zod';
/**
 * 의무축일 조회 입력 스키마
 */
export const getHolydaysInputSchema = z.object({
    year: z.number().int().min(1583).max(2100), // 그레고리력 기준
});
/**
 * 전례 시기 조회 입력 스키마
 */
export const getSeasonInputSchema = z.object({
    year: z.number().int().min(1583).max(2100).optional(),
});
